import { CircleSmallIcon } from './CircleSmallIcon';

/**
 * author: Michael Irigoyen
 * id 0EA34D8C-1A02-4A92-8293-991702ABD065
 * name circle-small
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-small.svg
 * tags
 * - Math 
 */
export const DotIcon = CircleSmallIcon;
export default DotIcon